import styles from "../styles/key.module.css";
import keyImg from "../assets/key.jpg";


export default function Key({ goHome }) {
return (
<div className={styles.container}>
<h1></h1>
<img src={keyImg} alt="Key" className={styles.image} />
<button onClick={goHome}>Back to Studio</button>
</div>
);
}